<article>
  <section>
    <p>You can add this asset to an existing issue.</p>
    <app-button label="Add to issue" (click)="clickSelectIssueToAdd()" />
  </section>
  <!--
  <section >
    <p>Create a new issue referencing this asset.</p>
    <app-button label="Create issue" (click)="dialog.set('new-issue')" (click)="createIssue()" />
  </section>
--></article>

@switch (dialog()) {
  @case ('add-to-issue') {
    <app-dialog (onClose)="dialog.set(null)" [canScroll]="true" header="Select issue">
      <main>
        <app-issue-tracking-list (onIssueSelected)="addToIssue($event)" [isPicker]="true" />
      </main>
    </app-dialog>
  }
  @case ('confirm-add-to-issue') {
    <app-dialog (onClose)="dialog.set(null)" [canScroll]="false" header="Confirm add to issue" [dimensions]="{ width: 500, height: 190 }">
      <div class="confirm-add-to-issue">
        <div class="mt-1 mb-1" title="Created by {{ issue().createdByName }} on {{ issue().createdAt | date: 'dd/MM/yy' }}" tooltipPosition="top">
          Add asset to <span>{{ issue().title }}</span> in <span>{{ issue().orgShortTitle }}</span> ?
        </div>
        <div class="text-right">
          <app-button [isCTA]="true" label="Add this asset to this issue" (click)="submitToIssue()" />
        </div>
      </div>
    </app-dialog>
  }
}
